import { Card, Progress, Typography } from "antd";
import React from "react";
import { useSelector } from "react-redux";

const { Text } = Typography;

const formatCurrency = (n) => {
  if (n >= 100000) return `₹${(n / 100000).toFixed(2)}L`;
  return `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
};

const METRIC_COLORS = {
  SALES: "#0891b2",
  PROFIT: "#16a34a",
  PURCHASE: "#7c3aed",
  MARGIN: "#d97706",
  INVOICES: "#dc2626",
};

const QuickMetrics = () => {
  const cardInfo = useSelector((state) => state.dashboard.list?.cardInfo) || {};
  const saleTotal = Number(cardInfo.sale_total) || 0;
  const saleProfit = Number(cardInfo.sale_profit) || 0;
  const purchaseTotal = Number(cardInfo.purchase_total) || 0;
  const marginPct = saleTotal > 0 ? ((saleProfit / saleTotal) * 100).toFixed(1) : "0";
  const invoiceCount = Number(cardInfo.sale_count) || 0;
  const maxAmount = Math.max(saleTotal, purchaseTotal, 1);

  const metrics = [
    { key: "SALES", label: "SALES", value: formatCurrency(saleTotal), percent: (saleTotal / maxAmount) * 100, color: METRIC_COLORS.SALES },
    { key: "PROFIT", label: "PROFIT", value: formatCurrency(saleProfit), percent: (saleProfit / maxAmount) * 100, color: METRIC_COLORS.PROFIT },
    { key: "PURCHASE", label: "PURCHASE", value: formatCurrency(purchaseTotal), percent: (purchaseTotal / maxAmount) * 100, color: METRIC_COLORS.PURCHASE },
    { key: "MARGIN", label: "MARGIN", value: `${marginPct}%`, percent: Math.min(Number(marginPct), 100), color: METRIC_COLORS.MARGIN },
    { key: "INVOICES", label: "INVOICES", value: `${invoiceCount} total`, percent: invoiceCount > 0 ? Math.min((invoiceCount / 20) * 100, 100) : 0, color: METRIC_COLORS.INVOICES },
  ];

  return (
    <Card
      title="Quick Metrics"
      size="small"
      className="dashboard-chart-card dashboard-chart-card-compact"
      extra={<Text type="secondary" style={{ fontSize: 12 }}>Period summary</Text>}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {metrics.map((m) => (
          <div key={m.key}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
              <Text strong style={{ fontSize: 12 }}>{m.label}</Text>
              <Text strong style={{ fontSize: 13 }}>{m.value}</Text>
            </div>
            <Progress
              percent={m.percent}
              showInfo={false}
              strokeColor={m.color}
              trailColor="#f0f0f0"
              size="small"
            />
          </div>
        ))}
      </div>
    </Card>
  );
};

export default QuickMetrics;
